<template>
	<Menu.Root :positioning="{ placement, gutter, sameWidth }" @select="emit('select', $event)">
		<Menu.Trigger as-child>
			<slot name="trigger" />
		</Menu.Trigger>
		<Menu.Positioner>
			<Menu.Content class="menu-content">
				<slot />
			</Menu.Content>
		</Menu.Positioner>
	</Menu.Root>
</template>

<script setup lang="ts">
import { Menu } from "@ark-ui/vue"
import type { MenuRootProps, MenuSelectionDetails } from "@ark-ui/vue"

withDefaults(
	defineProps<{
		gutter?: number
		sameWidth?: boolean
		placement?: NonNullable<MenuRootProps["positioning"]>["placement"]
	}>(),
	{
		gutter: 8,
		sameWidth: false,
		placement: "bottom-start",
	}
)

const emit = defineEmits<{
	select: [details: MenuSelectionDetails]
}>()
</script>

<style scoped>
.menu-content {
	background-color: var(--neutral-0);
	border: var(--border-width-thin) solid var(--neutral-200);
	border-radius: var(--border-radius-base);
	box-shadow: var(--shadow-sm);
	padding: var(--spacing-xxs);
	outline: none;
	z-index: 1000;
}
</style>
